import src from "IMAGE";
export default { src, width: 851, height: 336, blurWidth: 0, blurHeight: 0};
